import { useEffect } from "react";
import { usePostHog } from "@posthog/react";
import { authService } from "../services/auth.service";

export const usePostHogIdentify = () => {
  const posthog = usePostHog();

  useEffect(() => {
    if (authService.isAuthenticated()) {
      const decodedToken = authService.getDecodedToken();
      posthog.identify(decodedToken.sourceId, {
        email: decodedToken.email,
        firstName: decodedToken.firstName,
        lastName: decodedToken.lastName,
        username: decodedToken.username,
        type: decodedToken.source,
      });
    } else {
      posthog.reset();
    }
  }, []);
};
